module.exports = __webpack_public_path__ + "static/media/sports_11.a8d442e2.jpg";